<template>
  <section>
    <div class="container">
      <div class="row mb-5">
        <div class="col-12 text-center">
          <h1> Déclarer un sinistre</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body p-4">
              <div class="row">
                <div class="col-1">
                  <v-icon
                    icon="chevron-left"
                    class="cursor-pointer"
                    @click="cancelClaim"
                  />
                </div>
                <div class="col-10">
                  <div class="text-center">
                    <h4>Sinistre</h4>
                  </div>
                </div>
                <div class="col-12 col-md-10 mx-auto">
                  <v-custom-select
                    input-id="claim-reference"
                    label="Référence"
                    placeholder="MRP0123456789"
                    module-name="claim"
                    getter-name="reference"
                    :input-validation="(value) => value.code"
                    path="reference"
                    :list="referenceList"
                    class="my-2"
                  />
                  <v-custom-select
                    v-if="productId === 16"
                    input-id="claim-type"
                    label="Type de sinistre"
                    placeholder="Sélectionnez votre type de sinistre"
                    module-name="claim"
                    getter-name="type"
                    path="type"
                    action-module="claim"
                    :list="claimTypes"
                    class="my-2"
                  />
                  <v-date
                    input-id="claim-date"
                    label="Date du sinistre"
                    module-name="claim"
                    getter-name="claimDate"
                    path="claimDate"
                    :disabled-dates="disabledDates"
                    class="my-2"
                  />
                  <v-textarea
                    input-id="claim-context"
                    label="Déclaration circonstanciée"
                    module-name="claim"
                    getter-name="context"
                    placeholder="Expliquez-nous votre sinistre"
                    path="context"
                    class="my-2"
                  />
                </div>
                <div class="col-12 col-md-10 mx-auto">
                  <v-loader
                    class="w-100"
                    title="Continuer"
                    :disable-button="!isValid"
                    icon="arrow-white-right"
                    :next="goToFilesView"
                  />
                  <v-loader
                    class="w-100 mt-3"
                    color="block"
                    title="Annuler"
                    :next="cancelClaim"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomSelect2 from '@/components/common/input/CustomSelect2.vue';
import Date2 from '@/components/common/input/Date2.vue';
import Textarea from '@/components/common/input/Textarea.vue';

export default {
  name: 'ClaimDeclaration',
  components: {
    'v-custom-select': CustomSelect2,
    'v-date': Date2,
    'v-textarea': Textarea,
  },
  data() {
    return {
      disabledDates: {},
    };
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
      claimTypes: 'rater/claimsType',
      currentReference: 'claim/currentReference',
      context: 'claim/context',
      claimDate: 'claim/claimDate',
      claimType: 'claim/type',
    }),
    isValid() {
      const baseValid = this.currentReference
        && this.currentReference.code !== null
        && this.context !== null
        && this.context !== ''
        && this.claimDate !== null;
      if (this.productId === 16) {
        return baseValid && this.claimType !== '';
      }
      return baseValid;
    },
    productId() {
      return parseInt(this.$route.params.productId, 10);
    },
    referenceList() {
      if (this.productId) {
        return this.contracts
          .filter(({ status }) => status === 'ACTIVE')
          .filter(({ productId }) => productId === this.productId)
          .map(({ reference }) => ({
            name: reference,
            code: reference,
          }));
      }
      return this.contracts
        .filter(({ status }) => status === 'ACTIVE')
        .filter(({ productId }) => ![16, 1].includes(productId))
        .map(({ reference }) => ({
          name: reference,
          code: reference,
        }));
    },
  },
  mounted() {
    this.disabledDates = {
      to: ((d) => new Date(d.setDate(d.getDate() - 90)))(new Date()),
      from: ((d) => new Date(d.setDate(d.getDate())))(new Date()),
    };
  },
  methods: {
    goToFilesView() {
      return this.$router.push('/client/claim/files');
    },
    cancelClaim() {
      this.$store.dispatch('claim/clear');
      return this.$router.back() || Promise.resolve();
    },
  },
};
</script>
